const formatNumber = (value: number, decimals = 2): string => {
  if (!Number.isFinite(value)) return '--';
  return Number.isInteger(value)
    ? `${value}`
    : value.toFixed(decimals).replace(/\.?0+$/, '');
};

export const normalizeAssessmentScoreToMarks = (
  score: number | null | undefined,
  totalMarks: number | null | undefined,
  maxMarks: number | null | undefined = totalMarks,
): number | null => {
  if (score == null) {
    return null;
  }

  const numericScore = Number(score);
  if (!Number.isFinite(numericScore)) {
    return null;
  }

  const numericTotalMarks = Number(totalMarks ?? 0);
  const numericMaxMarks = Number(maxMarks ?? numericTotalMarks);
  const derivedMarks =
    numericTotalMarks > 0
    && Number.isFinite(numericMaxMarks)
    && numericMaxMarks > 0
    && numericScore > numericMaxMarks
    && numericScore <= 100
      ? (numericScore / 100) * numericTotalMarks
      : numericScore;

  const cappedMarks =
    Number.isFinite(numericMaxMarks) && numericMaxMarks > 0
      ? Math.min(derivedMarks, numericMaxMarks)
      : derivedMarks;

  return Number(cappedMarks.toFixed(2));
};

export const formatAssessmentScoreFromPercentage = (
  score: number | null | undefined,
  totalMarks: number | null | undefined,
): string => {
  if (score == null) {
    return '--';
  }

  const numericScore = Number(score);
  if (!Number.isFinite(numericScore)) {
    return '--';
  }

  const numericTotalMarks = Number(totalMarks ?? 0);
  if (!Number.isFinite(numericTotalMarks) || numericTotalMarks <= 0) {
    return formatNumber(numericScore);
  }

  const earnedMarks = (numericScore / 100) * numericTotalMarks;
  const displayedMarks = Math.min(earnedMarks, numericTotalMarks);
  const bonusMarks = Math.max(earnedMarks - numericTotalMarks, 0);
  const base = `${formatNumber(displayedMarks)}/${formatNumber(numericTotalMarks)}`;

  if (bonusMarks <= 0) {
    return base;
  }

  return `${base} (+${formatNumber(bonusMarks)} bonus)`;
};
